import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Typography, Box, Chip } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// ✅ FUNCIÓN PARA FORMATEAR LA VISTA PREVIA CON RESALTADO
const formatPromptPreview = (text) => {
    if (!text) return "";
    
    // Escapar HTML primero
    let html = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\n/g, '<br>');
    
    // Resaltar sintaxis [MEDIA: nombrearchivo.ext]
    html = html.replace(
        /\[MEDIA:\s*([^\]]+)\]/gi,
        '<span style="background-color: #dbeafe; color: #1e40af; padding: 2px 6px; border-radius: 4px; font-weight: bold; font-family: \'Courier New\', monospace;">[MEDIA: $1]</span>'
    );
    
    // Resaltar secciones (líneas que empiezan con ** o #)
    html = html.replace(
        /(\*\*[^*]+\*\*|#{1,6}\s+[^\n]+)/g,
        '<span style="background-color: #d1fae5; color: #065f46; padding: 4px 8px; border-radius: 4px; font-weight: bold; display: inline-block; margin-bottom: 4px;">$1</span>'
    );
    
    return html;
};

const ExpandedPromptModal = ({ open, promptText, onClose, onSave, onChange, hasChanges, classes }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={classes.expandedPromptDialog}
            maxWidth={false}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">
                        {i18n.t("promptModal.expanded.title")}
                    </Typography>
                    {hasChanges && (
                        <Chip 
                            label={i18n.t("promptModal.expanded.unsavedChip")} 
                            style={{ backgroundColor: '#ff9800', color: '#fff' }}
                            size="small"
                        />
                    )}
                </Box>
            </DialogTitle>
            <DialogContent className={classes.expandedPromptContent}>
                <Box display="flex" flexDirection="column" height="100%">
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        {i18n.t("promptModal.expanded.intro")}
                    </Typography>
                    
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={promptText}
                        onChange={(e) => onChange(e.target.value)}
                        className={classes.expandedPromptEditor}
                        placeholder={i18n.t("promptModal.expanded.editorPlaceholder")}
                        InputProps={{
                            style: {
                                height: "100%",
                            },
                        }}
                    />
                    
                    <Box display="flex" justifyContent="flex-end" marginTop={1}>
                        <Typography variant="body2" color="textSecondary" style={{ fontWeight: 500 }}>
                            {i18n.t("promptModal.expanded.charCount", { count: promptText.length })}
                        </Typography>
                    </Box>
                    
                    <Typography variant="subtitle2" style={{ marginTop: 16, marginBottom: 8 }}>
                        {i18n.t("promptModal.expanded.previewTitle")}
                    </Typography>
                    
                    <Box 
                        className={classes.expandedPromptPreview}
                        dangerouslySetInnerHTML={{
                            __html: formatPromptPreview(promptText)
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    onClick={onClose}
                    className={classes.cancelButton}
                >
                    {i18n.t("promptModal.buttons.cancel")}
                </Button>
                <Button
                    onClick={() => onSave(promptText)}
                    className={classes.saveButton}
                    disabled={!hasChanges}
                >
                    {i18n.t("promptModal.buttons.saveChanges")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ExpandedPromptModal;
